<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <div class="wen-yan show-book">
      <h5>【文言 - 乾】</h5>
      <p>
        【文言】曰：「元」者，善之長也；「亨」者，嘉之會也；「利」者，義之和也；「貞」者，事之幹也。
      </p>
      <p>
        君子體仁，足以長人；嘉會，足以合禮；利物，足以和義；貞固，足以幹事。君子行此四德者，故曰「乾：元、亨、利、貞」。
      </p>
      <p>
        初九曰：「潛龍勿用」，何謂也？子曰：「龍，德而隱者也。不易乎世，不成乎名，遯世无悶，不見是而无悶，樂則行之，憂則違之，確乎其不可拔，潛龍也。」
      </p>
      <p />
      <p>
        九二曰：「見龍在田，利見大人」，何謂也？子曰：「龍，德而正中者也。庸言之信，庸行之謹，閑邪存其誠，善世而不伐，德博而化。【易】曰：「見龍在田，利見大人」，君德也。」
      </p>
      <p>
        九三曰：「君子終日乾乾、夕惕若、厲、无咎」。何謂也？子曰：「君子，進德脩業。忠信，所以進德也；脩辭立其誠，所以居業也。知至至之，可與幾也，知終終之，可與存義也。是故居上位而不驕，在下位而不憂。故乾乾因其時而惕，雖危无咎矣。」
      </p>
      <p>
        九四曰：「或躍在淵，无咎。」何謂也？子曰：「上下无常，非為邪也；進退无恆，非離群也。君子進德脩業，欲及時也，故无咎。」
      </p>
      <p>
        九五曰：「飛龍在天，利見大人」。何謂也？子曰：「同聲相應，同氣相求。水流濕，火就燥；雲從龍，風從虎；聖人作而萬物覩。本乎天者親上，本乎地者親下，則各從其類也。」
      </p>
      <p>
        上九曰：「亢龍有悔」，何謂也？子曰：「貴而无位，高而无民，賢人在下位而无輔，是以動而有悔也。」
      </p>
      <p>
        「潛龍勿用」，下也。「見龍在田」，時舍也。「終日乾乾」，行事也。「或躍在淵」，自試也。「飛龍在天」，上治也。「亢龍有悔」、窮之災也。乾元「用九」，天下治也。
      </p>
      <p>
        「潛龍勿用」，陽氣潛藏。「見龍在田」，天下文明。「終日乾乾」，與時偕行。「或躍在淵」，乾道乃革。「飛龍在天」，乃位乎天德。「亢龍有悔」，與時偕極。乾元「用九」，乃見天則。
      </p>
      <p>
        「乾元」者，始而亨者也。「利貞」者，性情也。乾始能以美利利天下，不言所利，大矣哉！大哉乾乎！剛健中正，純粹精也；六爻發揮，旁通情也；時乘六龍，以御天也；雲行雨施，天下平也。
      </p>
      <p>
        君子以成德為行，日可見之行也。「潛」之為言也，隱而未見，行而未成，是以君子「弗用」也。
      </p>
      <p>
        君子學以聚之，問以辯之，寬以居之，仁以行之。【易】曰：「見龍在田、利見大人」，君德也。
      </p>
      <p>
        九三重剛而不中，上不在天，下不在田，故「乾乾」因其時而「惕」，雖危「无咎」矣。
      </p>
      <p>
        九四重剛而不中，上不在天，下不在田，中不在人，故「或」之。或之者、疑之也，故「无咎」。
      </p>
      <p>
        夫大人者、與天地合其德，與日月合其明，與四時合其序，與鬼神合其吉凶。先天而天弗違，後天而奉天時。天且弗違，而況於人乎？況於鬼神乎？
      </p>
      <p>
        「亢」之為言也，知進而不知退，知存而不知亡，知得而不知喪。其唯聖人乎？知進退存亡，而不失其正者，其唯聖人乎！
      </p>
      <br />
      <h5>【文言 - 坤】</h5>

      <p>
        【文言】曰：坤，至柔而動也剛，至靜而德方。後得主而有常，含萬物而化光。坤道其順乎！承天而時行。
      </p>
      <p>
        積善之家，必有餘慶；積不善之家，必有餘殃。
        臣弒其君，子弒其父，非一朝一夕之故，其所由來者漸矣，由辯之不早辯也。【易】曰：「履霜、堅冰至」，蓋言順也。
      </p>
      <p>
        「直」，其正也；「方」，其義也。君子敬以直內，義以方外，敬義立而德不孤。「直方大，不習无不利」，則不疑其所行也。
      </p>

      <p>
        陰雖有美，含之；以從「王事」，弗敢成也。
        地道也，妻道也，臣道也。地道「无成」而代「有終」也。
      </p>

      <p>天地變化，草木蕃；天地閉，賢人隱。</p>
      <p>
        【易】曰：「括囊，无咎，无譽」，蓋言謹也。
        君子黃中通理，正位居體，美在其中，而暢於四支，發於事業，美之至也。
      </p>
      <p>
        陰疑於陽必戰，為其嫌於无陽也，故稱「龍」焉；
        猶未離其類也，故稱「血」焉。 夫「玄黃」者、天地之雜也，天玄而地黃。
      </p>
    </div>
  </main>
{:else}
  <main>
    <div class="wen-yan show-book">
      <h5>【文言 - 乾】</h5>
      <p>
        【文言】曰：「元」者，善之长也；「亨」者，嘉之会也；「利」者，义之和也；「贞」者，事之干也。
      </p>
      <p>
        君子体仁，足以长人；嘉会，足以合礼；利物，足以和义；贞固，足以干事。君子行此四德者，故曰「乾：元、亨、利、贞」。
      </p>
      <p>
        初九曰：「潜龙勿用」，何谓也？子曰：「龙，德而隐者也。不易乎世，不成乎名，遯世无闷，不见是而无闷，乐则行之，忧则违之，确乎其不可拔，潜龙也。」
      </p>
      <p />
      <p>
        九二曰：「见龙在田，利见大人」，何谓也？子曰：「龙，德而正中者也。庸言之信，庸行之谨，闲邪存其诚，善世而不伐，德博而化。【易】曰：「见龙在田，利见大人」，君德也。」
      </p>
      <p>
        九三曰：「君子终日乾乾、夕惕若、厉、无咎」。何谓也？子曰：「君子，进德修业。忠信，所以进德也；修辞立其诚，所以居业也。知至至之，可与几也，知终终之，可与存义也。是故居上位而不骄，在下位而不忧。故乾乾因其时而惕，虽危无咎矣。」
      </p>
      <p>
        九四曰：「或跃在渊，无咎。」何谓也？子曰：「上下无常，非为邪也；进退无恒，非离群也。君子进德修业，欲及时也，故无咎。」
      </p>
      <p>
        九五曰：「飞龙在天，利见大人」。何谓也？子曰：「同声相应，同气相求。水流湿，火就燥；云从龙，风从虎；圣人作而万物覩。本乎天者亲上，本乎地者亲下，则各从其类也。」
      </p>
      <p>
        上九曰：「亢龙有悔」，何谓也？子曰：「贵而无位，高而无民，贤人在下位而无辅，是以动而有悔也。」
      </p>
      <p>
        「潜龙勿用」，下也。「见龙在田」，时舍也。「终日乾乾」，行事也。「或跃在渊」，自试也。「飞龙在天」，上治也。「亢龙有悔」、穷之灾也。乾元「用九」，天下治也。
      </p>
      <p>
        「潜龙勿用」，阳气潜藏。「见龙在田」，天下文明。「终日乾乾」，与时偕行。「或跃在渊」，乾道乃革。「飞龙在天」，乃位乎天德。「亢龙有悔」，与时偕极。乾元「用九」，乃见天则。
      </p>
      <p>
        「乾元」者，始而亨者也。「利贞」者，性情也。乾始能以美利利天下，不言所利，大矣哉！大哉乾乎！刚健中正，纯粹精也；六爻发挥，旁通情也；时乘六龙，以御天也；云行雨施，天下平也。
      </p>
      <p>
        君子以成德为行，日可见之行也。「潜」之为言也，隐而未见，行而未成，是以君子「弗用」也。
      </p>
      <p>
        君子学以聚之，问以辩之，宽以居之，仁以行之。【易】曰：「见龙在田、利见大人」，君德也。
      </p>
      <p>
        九三重刚而不中，上不在天，下不在田，故「乾乾」因其时而「惕」，虽危「无咎」矣。
      </p>
      <p>
        九四重刚而不中，上不在天，下不在田，中不在人，故「或」之。或之者、疑之也，故「无咎」。
      </p>
      <p>
        夫大人者、与天地合其德，与日月合其明，与四时合其序，与鬼神合其吉凶。先天而天弗违，后天而奉天时。天且弗违，而况于人乎？况于鬼神乎？
      </p>
      <p>
        「亢」之为言也，知进而不知退，知存而不知亡，知得而不知丧。其唯圣人乎？知进退存亡，而不失其正者，其唯圣人乎！
      </p>
      <br />
      <h5>【文言 - 坤】</h5>

      <p>
        【文言】曰：坤，至柔而动也刚，至静而德方。后得主而有常，含万物而化光。坤道其顺乎！承天而时行。
      </p>
      <p>
        积善之家，必有余庆；积不善之家，必有余殃。
        臣弑其君，子弑其父，非一朝一夕之故，其所由来者渐矣，由辩之不早辩也。【易】曰：「履霜、坚冰至」，盖言顺也。
      </p>
      <p>
        「直」，其正也；「方」，其义也。君子敬以直内，义以方外，敬义立而德不孤。「直方大，不习无不利」，则不疑其所行也。
      </p>

      <p>
        阴虽有美，含之；以从「王事」，弗敢成也。
        地道也，妻道也，臣道也。地道「无成」而代「有终」也。
      </p>

      <p>天地变化，草木蕃；天地闭，贤人隐。</p>
      <p>
        【易】曰：「括囊，无咎，无誉」，盖言谨也。
        君子黄中通理，正位居体，美在其中，而畅于四支，发于事业，美之至也。
      </p>
      <p>
        阴疑于阳必战，为其嫌于无阳也，故称「龙」焉；
        犹未离其类也，故称「血」焉。 夫「玄黄」者、天地之杂也，天玄而地黄。
      </p>
    </div>
  </main>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
</style>
